import { render } from "./ChromaticWheel.vue?vue&type=template&id=5970068a&scoped=true"
import script from "./ChromaticWheel.vue?vue&type=script&lang=ts"
export * from "./ChromaticWheel.vue?vue&type=script&lang=ts"

import "./ChromaticWheel.vue?vue&type=style&index=0&id=5970068a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5970068a"

export default script